import { render } from "./delivery-review.vue?vue&type=template&id=8547eabc&scoped=true"
import script from "./delivery-review.vue?vue&type=script&lang=js"
export * from "./delivery-review.vue?vue&type=script&lang=js"

import "./delivery-review.vue?vue&type=style&index=0&id=8547eabc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8547eabc"]])

export default __exports__